import Vue from 'vue';
import { capitalize, nullableToDashFormat } from '../helpers/filter';
import { numberFormat } from '../helpers/utils';

Vue.filter('capitalize', capitalize);
Vue.filter('nullableToDashFormat', nullableToDashFormat);
Vue.filter('numberFormat', numberFormat);
